import { render, staticRenderFns } from "./AssetVersionsTab.vue?vue&type=template&id=6488f8ec&scoped=true&"
import script from "./AssetVersionsTab.vue?vue&type=script&lang=js&"
export * from "./AssetVersionsTab.vue?vue&type=script&lang=js&"
import style0 from "./AssetVersionsTab.vue?vue&type=style&index=0&id=6488f8ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6488f8ec",
  null
  
)

export default component.exports